// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".code-row[data-v-4ff11700]{height:185px}.setting-row[data-v-4ff11700]{height:calc(100% - 185px)}", ""]);
